<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        v-if="windowWidth > 1500"
        class="pt-1 pr-0"
        cols="3"
      >
        <v-autocomplete
          v-model="filterJob"
          label="Job"
          :items="jobs"
          hide-details="true"
          :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
          item-value="id"
          clearable
          :single-select="false"
          :loading="loadingJobs"
        >
          <template #selection="{ item }">
            <v-chip
              v-if="item && (item.sub_class_color || item.sub_class_name)"
              small
              :color="item.sub_class_color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
          <template #item="{ item }">
            <v-chip
              v-if="item && (item.sub_class_color || item.sub_class_name)"
              small
              :color="item.sub_class_color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="pl-10"
      >
        <div class="d-flex align-center ga-3">
          <div class="d-flex flex-column align-center justify-center ga-1">
            <span
              style="font-size: 16px !important"
              class="fw600"
            >PRODUCTION ACCURACY</span>
            <div class="d-flex align-center ga-3">
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.yesterday_produced < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.yesterday_produced > 65 && windowAccuracy.yesterday_produced < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.yesterday_produced : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Yesterday</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Percentage of finished goods produced ahead of the production completion date — for yesterday only.</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.weekly_produced < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.weekly_produced > 65 && windowAccuracy.weekly_produced < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.weekly_produced : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Weekly</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Weekly average percentage of finished goods produced before the production completion date for this week</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.monthly_produced < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.monthly_produced > 65 && windowAccuracy.monthly_produced < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.monthly_produced : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Monthly</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Monthly average percentage of finished goods produced before the production completion date for this month</span>
              </v-tooltip>
            </div>
          </div>
          <div class="d-flex flex-column align-center justify-center ga-1">
            <span
              style="font-size: 16px !important"
              class="fw600"
            >SHIPPING ACCURACY</span>
            <div class="d-flex align-center ga-3">
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.yesterday < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.yesterday > 65 && windowAccuracy.yesterday < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.yesterday : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Yesterday</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Percentage of finished goods shipped ahead of the planned ship date — for yesterday only.</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.weekly < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.weekly > 65 && windowAccuracy.weekly < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.weekly : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Weekly</span>
                  </div>
                </template>
                <span>Shipping Window Accuracy – Weekly average percentage of finished goods shipped before the planned ship date for this week</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.monthly < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.monthly > 65 && windowAccuracy.monthly < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.monthly : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Monthly</span>
                  </div>
                </template>
                <span>Shipping Window Accuracy – Monthly average percentage of finished goods shipped before the planned ship date for this month</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row align="center">
      <v-col
        v-for="tab, idx in tabs"
        :key="idx"
        cols="auto"
        :style="`cursor: pointer; border-bottom: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '2px solid #1976d2' : 'none'};`"
        class="ml-2 mr-2"
        @click="tabChange(tab)"
      >
        <span :style="`font-size: 16px !important; color: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '#1976d2' : isDarkMode ? '' : 'rgba(0,0,0,0.8)'}; font-weight: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? 'bold' : 'normal'};`">{{ tab.name }}</span>
      </v-col>
      <!-- <v-tabs
        v-model="selectedTab"
        class="mb-4"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs> -->
      <v-spacer />
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          v-model="filterMenu"
          transition="scale-transition"
          offset-y
          min-width="500"
          nudge-left="50"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="success"
              outlined
              v-bind="attrs"
              v-on="on"
              @click="filterMenu = !filterMenu"
            >
              <v-icon
                small
                class="mr-1"
              >
                mdi-filter
              </v-icon>
              FILTERS
            </v-btn>
          </template>
          <v-card
            class="pa-8"
          >
            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <span style="font-size: 22px !important; font-weight: bold;">Filters</span>
                  </v-col>
                  <v-col class="text-end pr-1">
                    <v-btn
                      icon
                      :style="{color: isDarkMode ? '' : '#000000'}"
                      @click="filterMenu = !filterMenu"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="filterRecordType"
                      label="Records Type"
                      :items="recordTypes"
                      hide-details="true"
                      item-text="name"
                      item-value="id"
                      clearable
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="filterStage"
                      label="Production Stage"
                      :items="stages"
                      hide-details="true"
                      item-text="name"
                      item-value="id"
                      clearable
                    >
                      <template #selection="{ item }">
                        <v-row align="center">
                          <v-col
                            cols="auto"
                            class="pr-0"
                          >
                            <v-btn
                              elevation="0"
                              fab
                              outlined
                              tile
                              readonly
                              color="#FFD84D"
                              style="border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #FFD84D;"
                            >
                              <span
                                style="color: #000000;"
                              >{{ item.code }}</span>
                            </v-btn>
                          </v-col>
                          <v-col>
                            <span style="font-size: 14px !important;">{{ item.name }}</span>
                          </v-col>
                        </v-row>
                      </template>
                      <template #item="{ item }">
                        <v-row align="center">
                          <v-col
                            cols="auto"
                            class="pr-0"
                          >
                            <v-btn
                              elevation="0"
                              fab
                              outlined
                              tile
                              readonly
                              color="#FFD84D"
                              style="border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #FFD84D;"
                            >
                              <span
                                style="color: #000000;"
                              >
                                {{ item.code }}</span>
                            </v-btn>
                          </v-col>
                          <v-col>
                            <span style="font-size: 14px !important;">{{ item.name }}</span>
                          </v-col>
                        </v-row>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete
                      v-model="filterPo"
                      label="SP+S/U PO#"
                      :items="poNumbers"
                      hide-details
                      clearable
                      :loading="loadingPo"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuRequiredBy"
                      v-model="dateMenuRequiredBy"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterGlassReqBy"
                          label="Glass Required By"
                          readonly
                          v-bind="attrs"
                          append-icon="mdi-calendar"
                          hide-details
                          v-on="on"
                          @change="$refs.menuRequiredBy.save(filterGlassReqBy)"
                        />
                      </template>
                      <business-date-picker
                        v-model="filterGlassReqBy"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterGlassReqBy = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDate"
                      v-model="dateMenuShipDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDate.save(filterPlannedShipDate)"
                        >
                          <template slot="label">
                            Plan Ship Date From
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterPlannedShipDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDate = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDateEnd"
                      v-model="dateMenuShipDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDateEnd.save(filterPlannedShipDateEnd)"
                        >
                          <template slot="label">
                            Plan Ship Date To
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterPlannedShipDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDate"
                      v-model="dateMenuProductionCompletionDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDate.save(filterProductionCompletionDate)"
                        >
                          <template slot="label">
                            Production Completion Date From
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterProductionCompletionDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDate = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDateEnd"
                      v-model="dateMenuProductionCompletionDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDateEnd.save(filterProductionCompletionDateEnd)"
                        >
                          <template slot="label">
                            Production Completion Date To
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterProductionCompletionDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col
                    class="pt-8"
                    cols="auto"
                  >
                    <span :style="{color: isDarkMode ? '#ffffffb3' : '#00000099', fontSize: '16px !important'}">Hide</span>
                  </v-col>
                  <v-col
                    class="pl-0"
                  >
                    <v-switch
                      v-model="isGlassRelated"
                      hide-details
                      label="Show Glass Related Only"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col />
                </v-row>
                <v-row>
                  <v-spacer />
                  <v-col
                    cols="auto"
                    class="pr-0"
                  >
                    <v-btn
                      color="normal"
                      @click="filterMenu = !filterMenu"
                    >
                      <span style="font-size: 14px !important;">Close</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      @click="clearAllFilters"
                    >
                      Clear
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          offset-y
          min-width="400"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="orange"
              outlined
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                style="font-size: 20px;"
                class="pr-1"
              >
                mdi-cog
              </v-icon> MORE OPTIONS
            </v-btn>
          </template>
          <v-card>
            <div class="d-flex flex-column ga-4 pa-6">
              <div
                class="options-item-div"
                @click="openReturnedWindows()"
              >
                <v-icon style="color: #2563EB;">
                  mdi-window-restore
                </v-icon>
                <span style="color: #2563EB; font-weight: 600; font-size: 16px !important">RETURNED WINDOWS</span>
              </div>
              <div
                class="options-item-div"
                @click="openFinishedGoods()"
              >
                <v-icon style="color: #9333EA;">
                  mdi-window-maximize
                </v-icon>
                <span style="color: #9333EA; font-weight: 600; font-size: 16px !important">FINISHED GOODS</span>
              </div>
              <div
                v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin))"
                :disabled="!selectedItems || selectedItems.length === 0"

                class="options-item-div"
                @click="archiveAll()"
              >
                <v-icon style="color: #0D9488;">
                  mdi-archive-outline
                </v-icon>
                <span style="color: #0D9488; font-weight: 600; font-size: 16px !important">{{ status == 1 ? 'ARCHIVE' : 'RESTORE' }}</span>
              </div>
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                class="options-item-div"
                @click="runWebhook('pdf')"
              >
                <v-icon style="color: #DC2626;">
                  mdi-file-document-outline
                </v-icon>
                <span style="color: #DC2626; font-weight: 600; font-size: 16px !important">GENERATE PDF</span>
              </div>
              <div
                class="options-item-div"
                @click="runWebhook('xls')"
              >
                <v-icon style="color: #16A34A;">
                  mdi-file-excel-outline
                </v-icon>
                <span style="color: #16A34A; font-weight: 600; font-size: 16px !important">GENERATE XLS</span>
              </div>
              <!-- <div
                v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate)"
                class="options-item-div"
                @click="sendEmailPdf()"
              >
                <v-icon style="color: #D97706;">
                  mdi-email-outline
                </v-icon>
                <span style="color: #D97706; font-weight: 600; font-size: 16px !important">SEND EMAIL PDF</span>
              </div> -->
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                :disabled="selectedItems.length === 0"
                class="options-item-div"
                @click="openGlassRequiredByDateFormMultiple()"
              >
                <v-icon :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#DB2777'};`">
                  mdi-calendar-blank-outline
                </v-icon>
                <span :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#DB2777'}; font-weight: 600; font-size: 16px !important`">CHANGE GLASS REQUIRED BY DATE</span>
              </div>
              <div
                :disabled="selectedItems.length === 0"
                class="options-item-div"
                @click="openPlannedShipDateMultipleForm()"
              >
                <v-icon :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'};`">
                  mdi-truck-delivery-outline
                </v-icon>
                <span :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'}; font-weight: 600; font-size: 16px !important`">CHANGE PLAN SHIP DATE</span>
              </div>
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                style="width: 100%;"
                class="d-flex flex-column ga-4"
              >
                <div
                  class="d-flex align-center justify-space-between"
                >
                  <div class="options-item-div">
                    <div class="d-flex flex-column ">
                      <span style="font-size: 16px !important; color: #000; font-weight: 500;">View Mode - {{ isShowStages ? 'Show' : 'Hide' }} Stages</span>
                      <span style="font-size: 14px !important;">Toggle between Show and Hide stages </span>
                    </div>
                  </div>
                  <v-switch
                    v-model="isShowStages"
                    hide-details
                    class="mt-0"
                    @click.stop
                  />
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin))"
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-btn
          color="primary"
          outlined
          @click="open()"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Record
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="pa-1"
      >
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            fixed-header
            :loading="loading"
            dense
            :height="windowHeight"
            :server-items-length="totalItems"
            @update:options="updateOptions"
          >
            <template
              v-for="h in headers"
              #[`header.${h.value}`]="{ header }"
            >
              <v-tooltip
                :key="h.value"
                top
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>
                <span>{{ header.fullText }}</span>
              </v-tooltip>
            </template>
            <template #item="{ item }">
              <tr>
                <td
                  v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate))"
                  class="pl-1 pr-1"
                >
                  <v-checkbox
                    v-model="selectedItems"
                    :disabled="status == statusIdOnHand && selectedItems.length >= 1 && !selectedItems.includes(item)"
                    :value="item"
                    class="mt-0 mb-0 pt-0"
                    hide-details
                  />
                </td>
                <!-- <td class="pl-1 pr-1">
                  <v-chip
                    small
                    :color="item && item.class ? item.class.color : 'grey'"
                    text-color="white"
                  >
                    {{ item && item.class ? item.class.name : '' }}
                  </v-chip>
                </td> -->
                <td class="pl-1 pr-1">
                  <span><text-highlight :queries="search">{{ item.location ? formatLocation(item.location.name) : '' }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    top
                    color="transparent"
                    style="opacity: 1;"
                  >
                    <template #activator="{ on }">
                      <span
                        v-if="item.is_shipping && item.total_shipping == 0 && item.is_glaze == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#0000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#C8E6C9'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                      <span
                        v-else-if="item.is_ready_for_shipping == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#0000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#F8BBD0'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>

                      <span
                        v-else
                        style="font-weight: 500;"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                    </template>
                    <v-chip
                      v-if="item && (item.sub_class_color || item.sub_class_name)"
                      small
                      :color="item.sub_class_color"
                      text-color="white"
                    >
                      {{ item.sub_class_name }}
                    </v-chip>
                  </v-tooltip>
                </td>
                <td class="pl-1 pr-1">
                  <span><text-highlight :queries="search">{{ item.project_floor }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    color="black"
                    top
                  >
                    <template #activator="{ on }">
                      <span v-on="on"><text-highlight
                        :queries="search"
                        v-on="on"
                      >{{ item.wo_number }}</text-highlight></span>
                    </template>
                    <span>{{ item.created_at_po_min }}</span>
                  </v-tooltip>
                </td>
                <td
                  v-if="isShowStages && (!selectedTab || (selectedTab.id === tabIdDoors))"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.door_count }}</text-highlight></span>
                </td>
                <td
                  v-if="isShowStages && (!selectedTab || selectedTab.id === tabIdWindows)"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.window_count }}</text-highlight></span>
                </td>
                <td
                  v-if="isShowStages && (!selectedTab || selectedTab.id === tabIdWindows)"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.window_vertical_count }}</text-highlight></span>
                </td>
                <td
                  v-if="isShowStages && (!selectedTab || selectedTab.id === tabIdWindows)"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.window_horizontal_count }}</text-highlight></span>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <span>{{ item.total_release_qty }}</span>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :ripple="false"
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #FFD84D; background-color: ${item.is_material_available ? '#FFD84D' : ''}`"
                    @click="triggerStageChange(item, materialAvailableId)"
                  >
                    <span
                      v-if="item.is_material_available"
                      style="color: #000000;"
                    >M</span>
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :ripple="false"
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_cutting_before_paint > 0 ? '#FFD84D' : isCuttingBeforePaintComplete(item) ? '#4CAF50' : ''}; background-color: ${item.total_cutting_before_paint > 0 ? '#FFD84D' : isCuttingBeforePaintComplete(item) ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdMaterialAvailable, 'Cutting', cuttingBeforePaintId)"
                  >
                    <span
                      v-if="item.total_cutting_before_paint > 0"
                      style="color: #000000;"
                    >{{ item.total_cutting_before_paint }}</span>
                    <span
                      v-else-if="isCuttingBeforePaintComplete(item)"
                      style="color: #FFFFFF;"
                    >C</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td>
                <!-- <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_fabrication > 0 ? '#FFD84D' : item.is_assembly_before_paint == 1 ? '#4CAF50' : ''}; background-color: ${item.total_fabrication > 0 ? '#FFD84D' : item.is_assembly_before_paint == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdFabrication, 'Fabrication', fabricationId)"
                  >
                    <span
                      v-if="item.total_fabrication > 0"
                      style="color: #000000;"
                    >{{ item.total_fabrication }}</span>
                    <span
                      v-else-if="item.is_assembly_before_paint == 1"
                      style="color: #FFFFFF;"
                    >F</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td> -->
                <!-- <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_assembly_before_paint > 0 ? '#FFD84D' : item.is_welding == 1 ? '#4CAF50' : ''}; background-color: ${item.total_assembly_before_paint > 0 ? '#FFD84D' : item.is_welding == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdAssemblyBeforePaint, 'Assembly Before Paint', assemblyBeforePaintId)"
                  >
                    <span
                      v-if="item.total_assembly_before_paint > 0"
                      style="color: #000000;"
                    >{{ item.total_assembly_before_paint }}</span>
                    <span
                      v-else-if="item.is_welding == 1"
                      style="color: #FFFFFF;"
                    >ABP</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td> -->
                <!-- <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_welding > 0 ? '#FFD84D' : item.is_shipping_for_paint == 1 ? '#4CAF50' : ''}; background-color: ${item.total_welding > 0 ? '#FFD84D' : item.is_shipping_for_paint == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdWelding, 'Welding', weldingId)"
                  >
                    <span
                      v-if="item.total_welding > 0"
                      style="color: #000000;"
                    >{{ item.total_welding }}</span>
                    <span
                      v-else-if="item.is_shipping_for_paint == 1"
                      style="color: #FFFFFF;"
                    >W</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td> -->
                <td
                  v-if="isShowStages && (!selectedTab || selectedTab.id === tabIdDoors)"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    v-if="isCommDoors(item)"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipping_for_paint > 0 ? '#FFD84D' : item.is_hardware == 1 ? '#4CAF50' : ''}; background-color: ${item.total_shipping_for_paint > 0 ? '#FFD84D' : item.is_hardware == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdShippingForPaint, 'Shipping For Paint', shippingForPaintId)"
                  >
                    <span
                      v-if="item.total_shipping_for_paint > 0"
                      style="color: #000000;"
                    >{{ item.total_shipping_for_paint }}</span>
                    <span
                      v-else-if="item.is_hardware == 1"
                      style="color: #FFFFFF;"
                    >SP</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    disabled
                    color="#E0E0E0"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #E0E0E0; background-color: #E0E0E0`"
                  />
                </td>
                <td
                  v-if="isShowStages && (!selectedTab || selectedTab.id === tabIdDoors)"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    v-if="isCommDoors(item)"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_hardware > 0 ? '#FFD84D' : item.is_cut == 1 ? '#4CAF50' : ''}; background-color: ${item.total_hardware > 0 ? '#FFD84D' : item.is_cut == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdHardware, 'Hardware', hardwareId)"
                  >
                    <span
                      v-if="item.total_hardware > 0"
                      style="color: #000000;"
                    >{{ item.total_hardware }}</span>
                    <span
                      v-else-if="item.is_cut == 1"
                      style="color: #FFFFFF;"
                    >H</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    disabled
                    color="#E0E0E0"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #E0E0E0; background-color: #E0E0E0`"
                  />
                </td>
                <!-- <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_cut > 0 ? '#FFD84D' : item.is_brackets == 1 ? '#4CAF50' : ''}; background-color: ${item.total_cut > 0 ? '#FFD84D' : item.is_brackets == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdCutting, 'Cutting', cutId)"
                  >
                    <span
                      v-if="item.total_cut > 0"
                      style="color: #000000;"
                    >{{ item.total_cut }}</span>
                    <span
                      v-else-if="item.is_brackets == 1"
                      style="color: #FFFFFF;"
                    >C</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td> -->
                <!-- <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_bracket > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}; background-color: ${item.total_bracket > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdBrackets, 'Brackets', bracketsId)"
                  >
                    <span
                      v-if="item.total_bracket > 0"
                      style="color: #000000;"
                    >{{ item.total_bracket }}</span>
                    <span
                      v-else-if="item.is_assembled == 1"
                      style="color: #FFFFFF;"
                    >B</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td> -->
                <td
                  v-if="isShowStages && (!selectedTab || selectedTab.id === tabIdDoors)"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    v-if="isCommDoors(item)"
                    elevation="0"
                    fab
                    outlined
                    tile
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_assembled > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}; background-color: ${item.total_assembled > 0 ? '#FFD84D' : item.is_assembled == 1 ? '#4CAF50' : ''}`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdAssembled, 'Assembled', assembledId)"
                  >
                    <span
                      v-if="item.total_assembled > 0"
                      style="color: #000000;"
                    >{{ item.total_assembled }}</span>
                    <span
                      v-else-if="item.is_assembled == 1"
                      style="color: #FFFFFF;"
                    >A</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    disabled
                    color="#E0E0E0"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #E0E0E0; background-color: #E0E0E0`"
                  />
                </td>
                <td class="pl-1 pr-1 text-center">
                  <v-btn
                    v-if="item.is_prod_backlog && item.total_prod_backlog >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'} ;`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdFinishedGoods, 'Production Backlog', finishedGoodId)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_prod_backlog || item.total_prod_backlog == 0 ? item.total_prod_backlog : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.is_shipping && item.total_shipping >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdShipped, 'Shipping Backlog', shippedId)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_shipping || item.total_shipping == 0 ? item.total_shipping : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.is_received && item.total_shipped >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipped != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipped != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdReceived, 'Receiving Backlog', receivedId)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_shipped || item.total_shipped == 0 ? item.total_shipped : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.total_returned > 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_returned != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_returned != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdReturned, 'Returned', returnedId)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_returned || item.total_returned == 0 ? item.total_returned : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.total_quarantined > 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_quarantined != 0 ? '#D50000' : '#4CAF50'}; background-color: ${item.total_quarantined != 0 ? '#D50000' : '#4CAF50'};`"
                    @click="openCommercialScheduleFinishedGoodForm(item, finishedGoodCommercialStatusIdQuarantined, 'Quarantined', quarantinedId)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_quarantined || item.total_quarantined == 0 ? item.total_quarantined : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1 text-center">
                  <span
                    v-if="item.sp_po_number"
                    style="cursor: pointer;"
                    @click="openWindowBreakdown(item, typeIdSPItems)"
                  ><text-highlight :queries="search">{{ item.sp_po_number }}</text-highlight></span>
                  <span
                    v-else
                  >N/A</span>
                </td>
                <td
                  class="pl-1 pr-1"
                  @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) ? openMenuSPGlassNote(item.id) : ''"
                >
                  <v-btn
                    v-if="item.sp_note_status"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :color="item.sp_note_status.color"
                    :style="{
                      borderRadius: '4px',
                      width: item.sp_note_status.name === 'N/A' || item.sp_note_status.name === 'PEN' || (item.sp_note_status.id === noteStatusIdShort && item.sp_note && item.sp_note.length > 2) ? 'auto' : '25px',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid ${item.sp_note_status.color}`,
                      backgroundColor: `${item.sp_note_status.color}`,
                    }"
                  >
                    <span
                      v-if="item.sp_note_status.id === noteStatusIdShort"
                      style="color: #000000;"
                    >-{{ item.sp_note }}</span>
                    <span
                      v-else
                      :style="`color: ${item.sp_note_status_id === noteStatusIdZero ? '#FFF' : '#000'}`"
                    >{{ item.sp_note_status.name }}</span>
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="{
                      borderRadius: '4px',
                      width: 'auto',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid #E0E0E0`,
                      backgroundColor: `#E0E0E0`,
                      color: '#000000'
                    }"
                  >
                    <span>N/A</span>
                  </v-btn>
                </td>
                <td
                  v-if="!isShowStages"
                  class="text-center"
                >
                  <v-chip
                    v-if="item.sp_po_status"
                    small
                    :color="item && item.sp_po_status ? item.sp_po_status.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.sp_po_status ? item.sp_po_status.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1 text-center">
                  <span
                    v-if="item.su_po_number"
                    style="cursor: pointer;"
                    @click="openWindowBreakdown(item, typeIdSUItems)"
                  ><text-highlight :queries="search">{{ item.su_po_number }}</text-highlight></span>
                  <span
                    v-else
                  >N/A</span>
                </td>
                <td
                  class="pl-1 pr-1"
                  style="cursor: pointer;"
                  @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) ? openMenuSUGlassNote(item.id) : ''"
                >
                  <v-btn
                    v-if="item.su_note_status"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :color="item.su_note_status.color"
                    :style="{
                      borderRadius: '4px',
                      width: item.su_note_status.name === 'N/A' || item.su_note_status.name === 'PEN' || (item.su_note_status.id === noteStatusIdShort && item.su_note && item.su_note.length > 2) ? 'auto' : '25px',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid ${item.su_note_status.color}`,
                      backgroundColor: `${item.su_note_status.color}`
                    }"
                  >
                    <span
                      v-if="item.su_note_status.id === noteStatusIdShort"
                      :style="`color: #000;`"
                    >-{{ item.su_note }}</span>
                    <span
                      v-else
                      :style="`color: ${item.su_note_status_id === noteStatusIdZero ? '#FFF' : '#000'}`"
                    >{{ item.su_note_status.name }}</span>
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="{
                      borderRadius: '4px',
                      width: 'auto',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid #E0E0E0`,
                      backgroundColor: `#E0E0E0`,
                      color: '#000000'
                    }"
                  >
                    <span>N/A</span>
                  </v-btn>
                </td>
                <td
                  v-if="!isShowStages"
                  class="text-center"
                >
                  <v-chip
                    v-if="item.sg_po_status"
                    small
                    :color="item && item.sg_po_status ? item.sg_po_status.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.sg_po_status ? item.sg_po_status.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1 text-center">
                  <span
                    v-if="item.sg_po_number"
                    style="cursor: pointer;"
                    @click="openWindowBreakdown(item, typeIdSGItems)"
                  ><text-highlight :queries="search">{{ item.sg_po_number }}</text-highlight></span>
                  <span
                    v-else
                  >N/A</span>
                </td>
                <td
                  class="pl-1 pr-1"
                  style="cursor: pointer;"
                  @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) ? openMenuSUGlassNote(item.id) : ''"
                >
                  <v-btn
                    v-if="item.sg_note_status"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :color="item.sg_note_status.color"
                    :style="{
                      borderRadius: '4px',
                      width: item.sg_note_status.name === 'N/A' || item.sg_note_status.name === 'PEN' || (item.sg_note_status.id === noteStatusIdShort && item.sg_note && item.sg_note.length > 2) ? 'auto' : '25px',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid ${item.sg_note_status.color}`,
                      backgroundColor: `${item.sg_note_status.color}`
                    }"
                  >
                    <span
                      v-if="item.sg_note_status.id === noteStatusIdShort"
                      :style="`color: #000;`"
                    >-{{ item.sg_note }}</span>
                    <span
                      v-else
                      :style="`color: ${item.sg_note_status_id === noteStatusIdZero ? '#FFF' : '#000'}`"
                    >{{ item.sg_note_status.name }}</span>
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="{
                      borderRadius: '4px',
                      width: 'auto',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid #E0E0E0`,
                      backgroundColor: `#E0E0E0`,
                      color: '#000000'
                    }"
                  >
                    <span>N/A</span>
                  </v-btn>
                </td>
                <td
                  v-if="!isShowStages"
                  class="text-center"
                >
                  <v-chip
                    v-if="item.sg_po_status"
                    small
                    :color="item && item.sg_po_status ? item.sg_po_status.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.sg_po_status ? item.sg_po_status.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) ? openGlassRequiredByDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.glass_required_by_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.required_by_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.required_by_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) ? openProductionCompletionDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.production_completion_date_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.production_completion_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.production_completion_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <span :style="`color: ${item.production_accuracy && item.production_accuracy === 100 ? '#388E3C' : item.production_accuracy != null && isJobFinished(item) && item.production_accuracy < 100 ? '#D32F2F' : '#000'};`"><text-highlight :queries="search">{{ item.production_accuracy != null && isJobFinished(item) ? `${item.production_accuracy}%` : '-' }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) ? openPlannedShipDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.planned_ship_date_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.ship_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.ship_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <span :style="`color: ${item.windows_accuracy && item.windows_accuracy === 100 ? '#388E3C' : item.windows_accuracy != null && isJobShipped(item) && item.windows_accuracy < 100 ? '#D32F2F' : '#000'};`"><text-highlight :queries="search">{{ item.windows_accuracy != null && isJobShipped(item) ? `${item.windows_accuracy}%` : '-' }}</text-highlight></span>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <v-chip
                    v-if="item.delay_reason"
                    small
                    :color="item && item.delay_reason ? item.delay_reason.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.delay_reason ? item.delay_reason.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    v-if="item.last_note"
                    top
                    color="black"
                  >
                    <template #activator="{ on }">
                      <span
                        style="white-space: nowrap; color: rgb(255, 152, 0);"
                        v-on="on"
                      >
                        <v-btn
                          v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdCommercialScheduleSupervisor)"
                          icon
                          small
                          @click="openNotes(item.id)"
                        >
                          <v-icon
                            small
                          >
                            mdi-eye
                          </v-icon>
                        </v-btn>
                        <!-- <text-highlight
                          :queries="search"
                        >{{ item.last_note_short }}</text-highlight> -->
                      </span>
                    </template>
                    <span>{{ item.last_note }}</span>
                  </v-tooltip>
                </td>

                <td
                  id="cellOverflow"
                  :class="(isDarkMode ? 'theme--dark ' : '') + 'pl-0 pr-0 text-end'"
                >
                  <!-- <v-btn
                    v-if="item.status_id == statusIdOnHand"
                    class="ml-1 mt-1 mb-1"
                    color="primary"
                    outlined
                    small
                    @click="openEdit(item)"
                  >
                    EDIT
                  </v-btn>
                  <v-btn
                    v-if="item.status_id == statusIdOnHand"
                    class="ml-1 mt-1 mb-1 mr-1"
                    color="error"
                    outlined
                    small
                    @click="softDelete(item.id)"
                  >
                    DELETE
                  </v-btn> -->
                  <v-btn
                    v-if="item.is_shipping && item.total_shipping == 0 && ((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin)) && item.is_brackets == 1) && item.status_id === statusIdInProgress"
                    class="ml-1 mr-3 mt-1 mb-1 elevation-0"
                    color="#0BDE79"
                    small
                    @click="toggle(item.id, item.status_id)"
                  >
                    <span style="color: white;">DONE</span>
                  </v-btn>
                  <v-btn
                    v-if="((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin)) && item.status_id === statusIdCompleted)"
                    class="ml-1 mr-3 mt-1 mb-1 elevation-0"
                    color="#0BDE79"
                    small
                    @click="toggle(item.id, item.status_id)"
                  >
                    <span style="color: white;">RESTORE</span>
                  </v-btn>
                  <v-menu
                    v-if="item.status_id != statusIdOnHand"
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdCommercialScheduleSupervisor) || roles.includes(userRoleIdGlassHandler)"
                        @click="openNotes(item.id)"
                      >
                        <v-list-item-title style="color: #ff9800; font-weight: 600;">
                          NOTES {{ item.notes ? `(${item.notes.length})` : '' }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="toggle(item.id, item.status_id, true)"
                      >
                        <v-list-item-title style="color: purple; font-weight: 600;">
                          ARCHIVE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="delay(item)"
                      >
                        <v-list-item-title style="color: #00695C; font-weight: 600;">
                          DELAY
                        </v-list-item-title>
                      </v-list-item>
                      <!-- <v-divider />
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate))"
                        @click="openTruckForm(item)"
                      >
                        <v-list-item-title
                          style="color: gray; font-weight: 600;"
                        >
                          <v-icon
                            small
                            class="mr-1 mb-1"
                            color="gray"
                          >
                            fas fa-plus
                          </v-icon> ADD TRUCK
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate))) && item.truck_schedule_total > 0"
                        @click="redirectTrucks(item.job_id)"
                      >
                        <v-list-item-title
                          style="color: gray; font-weight: 600;"
                        >
                          VIEW TRUCKS {{ `(${item.truck_schedule_total})` }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider />
                      <v-list-item
                        v-if="!item.is_splander_paint && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="finishStage(item.id, spandrelId)"
                      >
                        <v-list-item-title style="color: #F7014C; font-weight: bold;">
                          FINISH SPANDREL
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-else-if="item.is_splander_paint && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="cancelStage(item.id, spandrelId)"
                      >
                        <v-list-item-title style="color: #F7014C; font-weight: bold;">
                          CANCEL SPANDREL
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="!item.is_panels && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="finishStage(item.id, panelsId)"
                      >
                        <v-list-item-title style="color: #1874A7; font-weight: bold;">
                          FINISH PANELS
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-else-if="item.is_panels && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="cancelStage(item.id, panelsId)"
                      >
                        <v-list-item-title style="color: #1874A7; font-weight: bold;">
                          CANCEL PANELS
                        </v-list-item-title>
                      </v-list-item> -->
                      <v-list-item
                        v-if="!item.is_material_available && item.status_id != statusIdOnHand && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdCommercialScheduleSupervisor) || roles.includes(userRoleIdGlassHandler))"
                        @click="finishStage(item.id, materialAvailableId)"
                      >
                        <v-list-item-title style="color: #F7A51C; font-weight: bold;">
                          FINISH MATERIAL
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu
                    v-else
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdCommercialScheduleSupervisor) || roles.includes(userRoleIdGlassHandler)"
                        @click="openNotes(item.id)"
                      >
                        <v-list-item-title style="color: #ff9800; font-weight: 600;">
                          NOTES {{ item.notes ? `(${item.notes.length})` : '' }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdCommercialScheduleAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-row v-else>
      <v-col>
        <window-breakdown-view
          :filter-location-id="filterLocationId"
          :filter-job="filterJob"
          :inventory-class-id="inventoryClassIdComm"
          :filter-planned-ship-date="filterPlannedShipDate"
          :filter-planned-ship-date-end="filterPlannedShipDateEnd"
          :filter-production-completion-date="filterProductionCompletionDate"
          :filter-production-completion-date-end="filterProductionCompletionDateEnd"
          :status="status"
          @open-notes="openNotes"
        />
      </v-col>
    </v-row> -->
    <v-dialog
      v-model="dialogProdBacklogSchedule"
      max-width="300px"
    >
      <v-card v-if="selectedProdBacklogItem">
        <v-card-text class="pt-6">
          <v-text-field
            v-model="selectedProdBacklogItem.production_backlog"
            label="Production Backlog"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogProdBacklogSchedule = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateProductionBacklog"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShipBacklogSchedule"
      max-width="300px"
    >
      <v-card v-if="selectedShipBacklogItem">
        <v-card-text class="pt-6">
          <v-text-field
            v-model="selectedShipBacklogItem.shipping_backlog"
            label="Shipping Backlog"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogShipBacklogSchedule = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateShipBacklog"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSPGlassNote"
      max-width="300px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-select
            v-model="selectedItem.sp_note_status_id"
            label="SP PO# Glass Note"
            item-value="id"
            item-text="name"
            :items="noteStatuses"
            clearable
          >
            <template slot="label">
              SU PO# Glass Note
            </template>
          </v-select>
          <v-text-field
            v-if="selectedItem.sp_note_status_id === noteStatusIdShort"
            v-model="selectedItem.sp_note"
            label="SP PO# Missing"
            type="number"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogSPGlassNote = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateSPGlassNote"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSUGlassNote"
      max-width="300px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-select
            v-model="selectedItem.su_note_status_id"
            label="SU PO# Glass Note"
            item-value="id"
            item-text="name"
            :items="noteStatuses"
            clearable
          >
            <template slot="label">
              SU PO# Glass Note
            </template>
          </v-select>
          <v-text-field
            v-if="selectedItem.su_note_status_id === noteStatusIdShort"
            v-model="selectedItem.su_note"
            label="SU PO# Missing"
            type="number"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogSUGlassNote = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateSUGlassNote"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogGlassRequiredByDateMultiple"
      max-width="350px"
    >
      <v-card>
        <v-card-title class="business-date-picker-dialog-title">
          Glass Required By Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="glassRequiredByDateMultiple"
                no-title
                scrollable
                :min="getScheduleDateLimitDate(getMinGlassRequiredByDate(), selectedItems)"
                :max="getScheduleDateLimitDate(getMaxGlassRequiredByDate, selectedItems)"
                @input="onGlassRequiredByDateChange(glassRequiredByDateMultiple, selectedItems)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogGlassRequiredByDateMultiple = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updateGlassRequiredByDateMultiple()"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShipDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-title class="business-date-picker-dialog-title">
          Glass Required By Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.glass_required_by"
                no-title
                scrollable
                :min="getScheduleDateLimitDate(minGlassRequiredByDate)"
                @input="onGlassRequiredByDateChange(selectedItem.glass_required_by)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogShipDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updateGlassRequiredByDate(selectedItem.id, selectedItem.glass_required_by)"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProductionCompletionDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-title class="business-date-picker-dialog-title">
          Production Completion Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.production_completion_date"
                no-title
                scrollable
                :min="getScheduleDateLimitDate(getMinDateProd())"
                @input="onProductionCompletionDateChange(selectedItem.production_completion_date)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-text-field
                v-model="selectedItem.production_completion_time"
                type="time"
                :rules="[(v) => !!v || 'Production Copmetion Time is required']"
              >
                <template slot="label">
                  Production Copmetion Time<RedAsterisk />
                </template>
              </v-text-field>
            </v-col>
          </v-row> -->
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogProductionCompletionDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updateProductionCompletionDate(selectedItem.id, selectedItem.production_completion_date, selectedItem.production_completion_time)"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProductionCompletionDateMultiple"
      max-width="350px"
    >
      <v-card>
        <v-card-title class="business-date-picker-dialog-title">
          Production Completion Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="productionCompletionDateMultiple"
                :min="getScheduleDateLimitDate(getMinDateProd(), selectedItems)"
                no-title
                scrollable
                @input="onProductionCompletionDateChange(productionCompletionDateMultiple, selectedItems)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogProductionCompletionDateMultiple = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updateProductionCompletionDateMultiple()"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlannedDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-title class="business-date-picker-dialog-title">
          Planned Ship Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.planned_ship_date"
                no-title
                scrollable
                :min="getScheduleDateLimitDate(getMinShipDate())"
                @input="onPlannedShipDateChange(selectedItem.planned_ship_date)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-text-field
                v-model="selectedItem.planned_ship_time"
                type="time"
                :rules="[(v) => !!v || 'Ship Time is required']"
              >
                <template slot="label">
                  Ship Time<RedAsterisk />
                </template>
              </v-text-field>
            </v-col>
          </v-row> -->
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogPlannedDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updatePlannedShipDate(selectedItem.id, selectedItem.planned_ship_date, selectedItem.planned_ship_time)"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlannedShipDateMultiple"
      max-width="500px"
      min-width="500px"
    >
      <v-card style="min-width: 500px;">
        <v-card-title class="business-date-picker-dialog-title">
          Planned Ship Date
        </v-card-title>
        <v-card-text>
          <v-form ref="formJob">
            <v-autocomplete
              v-model="selectedLocationId"
              :items="locations"
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'Job Location is required']"
              clearable
              class="mb-3"
            >
              <template slot="label">
                Job Location<RedAsterisk />
              </template>
            </v-autocomplete>
          </v-form>
          <business-date-picker
            v-model="plannedShipDateMultiple"
            no-title
            scrollable
            :min="getScheduleDateLimitDate(getMinDate(true), selectedItems)"
            @input="onPlannedShipDateChange(plannedShipDateMultiple, selectedItems)"
            width="100%"
          />
          <sealed-unit-overbooking-status-chip
            class="mx-4 mb-2"
            :message="sealedUnitOverbookedErrorMessage"
            :checking="isCheckingSealedUnitCount"
            :overbooked="isSealedUnitOverbooked"
            :checked="isSealedUnitCountChecked"
          />
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogPlannedShipDateMultiple = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updatePlannedShipDateMultiple();"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <commercial-schedule-form
      ref="commercialForm"
      @success="get()"
    />

    <commercial-schedule-note-form
      ref="commercialScheduleNoteForm"
      @success="get()"
    />

    <!-- <commercial-schedule-history-form
      ref="commercialScheduleHistoryForm"
      @success="get()"
    /> -->

    <truck-schedule-approve-form
      ref="approveForm"
      @success="get()"
    />

    <commercial-schedule-finished-good-form
      ref="commercialScheduleFinishedGoodForm"
    />

    <!-- <window-breakdown-items-form
      ref="windowBreakdownItemsForm"
    /> -->

    <commercial-schedule-finished-good-grouped-form
      ref="commercialScheduleFinishedGoodGroupedForm"
    />

    <bill-of-lading-returned-windows-form
      ref="billOfLadingReturnedWindowsForm"
    />

    <commercial-schedule-delay-reason-form
      ref="commercialScheduleDelayReasonForm"
      @success="get()"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import { addBusinessDays } from '@/helpers/BusinessDateHelper';
import BusinessDatePicker from '@/components/elements/BusinessDatePicker.vue';
import SealedUnitOverbookingStatusChip from '@/components/elements/SealedUnitOverbookingStatusChip.vue';
import CommercialScheduleForm from '@/components/forms/commercialSchedules/CommercialScheduleForm';
import CommercialScheduleNoteForm from '@/components/forms/commercialSchedules/CommercialScheduleNoteForm';
// import CommercialScheduleHistoryForm from '@/components/forms/commercialSchedules/CommercialScheduleHistoryForm';
import TruckScheduleApproveForm from '@/components/forms/truckSchedules/TruckScheduleApproveForm';
// import WindowBreakdownView from '@/views/ProductionSchedules/WindowBreakdownView';
import CommercialScheduleFinishedGoodForm from '@/components/forms/commercialSchedules/CommercialScheduleFinishedGoodForm';
import * as FormatHelpers from '@/helpers/FormatHelpers';
import { saveAs } from 'file-saver';
import WindowBreakdownItemsForm from '@/components/forms/productionSchedules/WindowBreakdownItemsForm';
import CommercialScheduleFinishedGoodGroupedForm from '@/components/forms/commercialSchedules/CommercialScheduleFinishedGoodGroupedForm';
import BillOfLadingReturnedWindowsForm from '@/components/forms/billOfLadings/BillOfLadingReturnedWindowsForm.vue';
import CommercialScheduleDelayReasonForm from '@/components/forms/commercialSchedules/CommercialScheduleDelayReasonForm.vue';


export default {
  components: {
    BusinessDatePicker,
    SealedUnitOverbookingStatusChip,
    CommercialScheduleForm,
    CommercialScheduleNoteForm,
    // CommercialScheduleHistoryForm,
    TruckScheduleApproveForm,
    // WindowBreakdownView,
    CommercialScheduleFinishedGoodForm,
    WindowBreakdownItemsForm,
    CommercialScheduleFinishedGoodGroupedForm,
    BillOfLadingReturnedWindowsForm,
    CommercialScheduleDelayReasonForm,
  },
  props: {

  },
  data: () => ({
    items: [],
    totalItems: 0,
    allItems: [],
    loading: false,
    filterJob: null,
    filterPo: null,
    filterStage: null,
    filterGlassReqBy: null,
    filterPlannedShipDate: null,
    filterPlannedShipDateEnd: null,
    filterProductionCompletionDate: null,
    filterProductionCompletionDateEnd: null,
    // filterLocationId: null,
    filterJobSubClass: null,
    filterRecordType: null,
    dateMenu: false,
    jobs: [],
    poNumbers: [],
    stages: [
      { name: 'Material', id: 1, code: 'M' },
      { name: 'Cutting', id: 2, code: 'C' },
      { name: 'Fabrication', id: 3, code: 'F' },
      { name: 'Assembly Before Paint', id: 4, code: 'ABP' },
      { name: 'Welding', id: 5, code: 'W' },
      { name: 'Shipping For Paint', id: 6, code: 'SFP' },
      { name: 'Hardware', id: 7, code: 'H' },
      { name: 'Cut', id: 8, code: 'C' },
      { name: 'Brackets', id: 9, code: 'B' },
      { name: 'Assembled', id: 10, code: 'A' },
    ],
    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },

    inventoryClassIdComm: 6,

    statusIdInProgress: 1,
    statusIdCompleted: 2,
    statusIdOnHand: 3,

    noteStatusIdShort: 2,
    noteStatusIdZero: 3,

    //these are actually stage progressions
    materialAvailableId: 1,
    cuttingBeforePaintId: 2,
    fabricationId: 3,
    assemblyBeforePaintId: 4,
    weldingId: 5,
    shippingForPaintId: 6,
    hardwareId: 7,
    cutId: 8,
    bracketsId: 9,
    assembledId: 10,
    finishedGoodId: 11,
    bundledId: 12,
    onSkidId: 13,
    loadedId: 14,
    shippedId: 15,
    receivedId: 16,
    returnedId: 17,
    quarantinedId: 18,

    finishedGoodCommercialStatusIdMaterialAvailable: 2,
    finishedGoodCommercialStatusIdCuttingBeforePaint: 14,
    finishedGoodCommercialStatusIdFabrication: 15,
    finishedGoodCommercialStatusIdAssemblyBeforePaint: 16,
    finishedGoodCommercialStatusIdWelding: 17,
    finishedGoodCommercialStatusIdShippingForPaint: 18,
    finishedGoodCommercialStatusIdHardware: 19,
    finishedGoodCommercialStatusIdCutting: 3,
    finishedGoodCommercialStatusIdBrackets: 5,
    finishedGoodCommercialStatusIdAssembled: 4,
    finishedGoodCommercialStatusIdFinishedGoods: 8,
    finishedGoodCommercialStatusIdShipped: 9,
    finishedGoodCommercialStatusIdReceived: 10,
    finishedGoodCommercialStatusIdReturned: 12,
    finishedGoodCommercialStatusIdQuarantined: 13,

    userRoleIdCommercialScheduleAdmin: 41,
    userRoleIdCommercialScheduleSupervisor: 42,
    
    topSpaceHeight: 300,
    windowHeight: 1000,
    windowWidth: 1000,
    status: null,
    pagination: {
      itemsPerPage: 500,
      page: 1,
    },
    sort: {
      order_by_first: 'production_completion_date',
      direction_sort: true,
    },
    filterMenu: false,
    dateMenuRequiredBy: false,
    dateMenuShipDate: false,
    dateMenuShipDateEnd: false,
    dateMenuProductionCompletionDate: false,
    dateMenuProductionCompletionDateEnd: false,
    roles: [],
    locations: [],
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    // userRoleIdSplanderPaintSupervisor: 21,
    recordTypes: [{ id: 1, name: 'Default Records' }, { id: 2, name: 'Manual Records' }],
    selectedItems: [],
    tabs: [{ id: 1, name: 'DOORS', color: '#E53935', sub_class_id: 7}, { id: 2, name: 'WINDOWS', color: '#FDD835', sub_class_id: 5}],
    tabIdDoors: 1,
    tabIdWindows: 2,
    // locationTabFilter: null,
    selectedTab: null,
    selectedProdBacklogItem: null,
    dialogProdBacklogSchedule: false,
    dialogShipBacklogSchedule: false,
    selectedShipBacklogItem: null,
    dialogSPGlassNote: false,
    dialogSUGlassNote: false,
    dialogShipDate: false,
    dialogPlannedDate: false,
    dialogProductionCompletionDate: false,
    selectedItem: null,
    noteStatuses: [],
    isShowStages: true,
    typeIdSUItems: 1,
    typeIdSPItems: 2,
    typeIdSGItems: 3,
    loadingJobs: false,
    loadingPo: false,
    dialogGlassRequiredByDateMultiple: false,
    dialogPlannedShipDateMultiple: false,
    dialogProductionCompletionDateMultiple: false,
    productionCompletionDateMultiple: null,
    glassRequiredByDateMultiple: null,
    plannedShipDateMultiple: null,
    isGlassRelated: false,
    windowAccuracy: null,
    minGlassRequiredByDate: null,
    today: new Date().toISOString().substr(0, 10),
    isCheckingSealedUnitCount: false,
    isSealedUnitOverbooked: false,
    isSealedUnitCountChecked: false,
    sealedUnitOverbookedDate: null,
    maximumSealedUnitsAllowedPerDay: 300,
    selectedLocationId: null,
    noteStatusIdOk: 1,
    subClassIdCommWindows: 5,
    subClassIdCommDoors: 7,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
      commercialScheduleState: (state) => state.commercialScheduleState,
      holidaysDateToNameMap: (state) => state.holidaysDateToNameMap,
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    dayAfterTomorrow() {
      return addBusinessDays(this.today, 2, this.holidaysDateToNameMap);
    },
    dayAfterSix() {
      return addBusinessDays(this.today, 6, this.holidaysDateToNameMap);
    },
    sealedUnitOverbookedErrorMessage() {
      if (this.isCheckingSealedUnitCount) return 'Checking Sealed Units...';
      const overbookedDate = this.sealedUnitOverbookedDate || 'this date';
      const formattedDate = this.sealedUnitOverbookedDate
        ? moment(this.sealedUnitOverbookedDate, 'YYYY-MM-DD').format('MMM D, YYYY')
        : overbookedDate;
      if (this.isSealedUnitOverbooked) {
        return `Sealed Units overbooked for ${formattedDate}`;
      }
      if (this.isSealedUnitCountChecked) {
        return 'Sealed Unit capacity OK';
      }
      return null;
    },
    headers() {
      const headers = [];
      if (this.roles.includes(this.userRoleIdAdmin) || this.roles.includes(this.userRoleIdCommercialScheduleAdmin) || this.roles.includes(this.userRoleIdAssociate)) {
        headers.push({
          text: '', fullText: '', value: 'checkbox', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
      }
      // headers.push({
      //   text: 'Class', fullText: 'Class', value: 'class', class: 'pl-1 pr-1', width: '2%',
      // });
      headers.push({
        text: 'Loc.', fullText: 'Location', value: 'location', class: 'pl-1 pr-1', width: '3%',
      });
      headers.push({
        text: 'Project', fullText: 'Project', value: 'project', class: 'pl-1 pr-1',
      });
      headers.push({
        text: 'Floor', fullText: 'Floor', value: 'project_floor', class: 'pl-1 pr-1',
      });
      headers.push({
        text: 'WO#', fullText: 'WO#', value: 'wo_number', class: 'pl-1 pr-1', width: '2%',
      });
      if (this.isShowStages) {
        // if a tab is selected and the tab is Doors then show Doors column, but if a tab isn't selected, show Doors column as well
        if (this.selectedTab && this.selectedTab.id === this.tabIdDoors || !this.selectedTab) {
          headers.push({
            text: 'Doors', fullText: 'Doors (count)', value: 'door_count', class: 'pl-1 pr-1', width: '2%', sortable: false,
          })
        }
        // if a tab is selected and the tab is verticals/horizontals then show verticals and horizontals column, but if a tab isn't selected, show verticals/horizontals column as well
        if (this.selectedTab && this.selectedTab.id === this.tabIdWindows || !this.selectedTab) {
          headers.push({
            text: 'Win.', fullText: 'Windows (count)', value: 'window_count', class: 'pl-1 pr-1', width: '2%', sortable: false,
          })
          headers.push({
            text: 'V.', fullText: 'Verticals (count)', value: 'window_vertical_count', class: 'pl-1 pr-1', width: '2%', sortable: false,
          })
          headers.push({
            text: 'H.', fullText: 'Horizontals (count)', value: 'window_horizontal_count', class: 'pl-1 pr-1', width: '2%', sortable: false,
          })
        }
        headers.push({
          text: 'Total Rel. Qty', fullText: 'Total Release Quantity', value: 'total_release_qty', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Mat. Av.', fullText: 'Material Available?', value: 'is_material_available', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Cut.', fullText: 'Cutting', value: 'is_cutting_before_paint', class: 'pl-1 pr-1', width: '2%', sortable: false,
        })
        // headers.push({
        //   text: 'Fab.', fullText: 'Fabrication', value: 'is_fabrication', class: 'pl-1 pr-1', width: '2%', sortable: false,
        // })
        // headers.push({
        //   text: 'As. B. Pnt.', fullText: 'Assembly Before Paint', value: 'is_assembly_before_paint', class: 'pl-1 pr-1', width: '2%', sortable: false,
        // })
        // headers.push({
        //   text: 'Weld.', fullText: 'Welding', value: 'is_welding', class: 'pl-1 pr-1', width: '2%', sortable: false,
        // })
        // if a tab is selected and the tab is Doors then show Shipping for Paint, Hardware and Assembly Before Paint columns, but if a tab isn't selected, show Shipping for Paint, Hardware and Assembly Before Paint columns as well
        if (this.selectedTab && this.selectedTab.id === this.tabIdDoors || !this.selectedTab) {
          headers.push({
            text: 'Shp. for Pnt.', fullText: 'Shipping for Paint', value: 'is_shipping_for_paint', class: 'pl-1 pr-1', width: '2%', sortable: false,
          })
          headers.push({
            text: 'Hrdw.', fullText: 'Hardware', value: 'is_hardware', class: 'pl-1 pr-1', width: '2%', sortable: false,
          })
          // headers.push({
          //   text: 'Cut.', fullText: 'Cutting', value: 'is_cut', class: 'pl-1 pr-1', width: '2%', sortable: false,
          // })
          // headers.push({
          //   text: 'Brkt.', fullText: 'Brackets', value: 'is_brackets', class: 'pl-1 pr-1', width: '2%', sortable: false,
          // })
          headers.push({
            text: 'As.', fullText: 'Assembled', value: 'is_assembled', class: 'pl-1 pr-1', width: '2%', sortable: false,
          })
        }
      }

      headers.push({
        text: 'Prod. Back', fullText: 'Production Backlog', value: 'production_backlog', class: 'pl-1 pr-1', width: '3%', sortable: false,
      });
      headers.push({
        text: 'Ship. Back', fullText: 'Shipping Backlog', value: 'shipping_backlog', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'Rec. Back', fullText: 'Receiving Backlog', value: 'received_backlog', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'Ret.', fullText: 'Returned Items', value: 'returned_backlog', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'Quar.', fullText: 'Quarantined', value: 'quarantined', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'SP PO#', fullText: 'SP PO#', value: 'sp_po_number', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Gl. Note', fullText: 'Glass Notes', value: 'sp_note', class: 'pl-1 pr-1', width: '3%', sortable: false,
      });
      if (!this.isShowStages) {
        headers.push({
          text: 'Status', fullText: 'Status', value: 'sp_po_status', class: 'pl-1 pr-1', width: '5%', sortable: false, align: 'center',
        });
      }
      headers.push({
        text: 'S/U PO#', fullText: 'S/U PO#', value: 'su_po_number', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Gl. Note', fullText: 'Glass Notes', value: 'su_note', class: 'pl-1 pr-1', width: '3%', sortable: false,
      });
      if (!this.isShowStages) {
        headers.push({
          text: 'Status', fullText: 'Status', value: 'su_po_status', class: 'pl-1 pr-1', width: '5%', sortable: false, align: 'center',
        });
      }
      headers.push({
        text: 'SG PO#', fullText: 'SG PO#', value: 'sg_po_number', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Gl. Note', fullText: 'Glass Notes', value: 'sg_note', class: 'pl-1 pr-1', width: '3%', sortable: false,
      });
      if (!this.isShowStages) {
        headers.push({
          text: 'Status', fullText: 'Status', value: 'sg_po_status', class: 'pl-1 pr-1', width: '5%', sortable: false, align: 'center',
        });
      }
      headers.push({
        text: 'Glass Req. By', fullText: 'Glass Required By', value: 'glass_required_by', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow_required_by', class: 'pl-0 pr-0', width: '1%', sortable: false,
      });
      headers.push({
        text: 'Prod. Comp. Date', fullText: 'Production Completion Date', value: 'production_completion_date', class: 'pl-1 pr-0', width: '2%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '1%', sortable: false,
      });
      headers.push({
        text: 'Prod. Acc.', fullText: 'Production Accuracy - Average percentage of finished goods produced ahead of the planned ship date', value: 'windows_accuracy', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Plan. Ship Date', fullText: 'Planned Shi Date', value: 'planned_ship_date', class: 'pl-1 pr-0', width: '2%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '1%', sortable: false,
      });
      headers.push({
        text: 'Ship. Acc.', fullText: 'Shipping Accuracy - Average percentage of finished goods shipped ahead of the planned ship date', value: 'windows_accuracy', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Delay Reason', fullText: 'Delay Reason', value: 'delay_reason', class: 'pl-1 pr-1', width: '5%', sortable: false, align: 'center',
      });
      headers.push({
        text: 'Note', fullText: 'Note', value: 'last_note', class: 'pl-1 pr-1', width: '5%', sortable: false,
      });
      headers.push({
        text: '', value: 'actions', align: 'end', class: 'pl-0 pr-0', sortable: false,
      });
      return headers;
    },
    getMaxGlassRequiredByDate() {
      if (this.selectedItem && this.selectedItem.production_completion_date) {
        return this.selectedItem.production_completion_date;
      }
      return null;
    },
    getMaxProductionCompletionDate() {
      if (this.selectedItem && this.selectedItem.planned_ship_date) {
        return this.selectedItem.planned_ship_date;
      }
      return null;
    },
  },
  watch: {
    filterJob(value) {
      this.storeState('job_id', value);
      this.get();
    },
    filterPo(value) {
      this.storeState('po_number', value);
      this.get();
    },
    filterStage(value) {
      this.storeState('stage', value);
      this.get();
    },
    filterGlassReqBy(value) {
      this.storeState('glass_required_by', value);
      this.get();
    },
    filterPlannedShipDate(value) {
      this.storeState('planned_ship_date', value);
      this.get();
    },
    filterPlannedShipDateEnd(value) {
      this.storeState('planned_ship_date_end', value);
      this.get();
    },
    filterProductionCompletionDate(value) {
      this.storeState('production_completion_date', value);
      this.get();
    },
    filterProductionCompletionDateEnd(value) {
      this.storeState('production_completion_date_end', value);
      this.get();
    },
    // filterLocationId() {
    //   this.get();
    // },
    filterRecordType(value) {
      this.storeState('record_type', value);
      this.get();
    },
    filterJobSubClass() {
      this.get();
    },
    status() {
      this.get();
    },
    pagination() {
      this.get();
    },
    $route(to) {
      this.status = to.params.status;
      // if (this.status === this.statusIdOnHand) {
      //   this.pagination.sortBy = ['po_number'];
      // } else {
      //   this.pagination.sortBy = ['planned_ship_date'];
      // }
    },
    search() {
      this.get();
    },
    // locationTabFilter() {
    //   if (this.locationTabFilter === 0) {
    //     this.filterLocationId = null;
    //     this.get();
    //     return;
    //   }
    //   const location = this.tabLocations[this.locationTabFilter];
    //   if (!location) return;
    //   this.filterLocationId = location.id;
    //   this.get();
    // },
    isShowStages(value) {
      this.storeState('isShowStages', value);
    },
    isGlassRelated(value) {
      this.storeState('isGlassRelated', value);
      this.get();
    },
  },
  created() {
    this.status = this.$route.params.status;
    if (!this.status) return;
    if (this.commercialScheduleState) {
      if (this.commercialScheduleState.pagination) { this.pagination = this.commercialScheduleState.pagination; }
      if (this.commercialScheduleState.job_id) { this.filterJob = this.commercialScheduleState.job_id; }
      if (this.commercialScheduleState.po_number) { this.filterPo = this.commercialScheduleState.po_number; }
      if (this.commercialScheduleState.stage) { this.filterStage = this.commercialScheduleState.stage; }
      if (this.commercialScheduleState.glass_required_by) { this.filterGlassReqBy = this.commercialScheduleState.glass_required_by; }
      if (this.commercialScheduleState.planned_ship_date) { this.filterPlannedShipDate = this.commercialScheduleState.planned_ship_date; }
      if (this.commercialScheduleState.planned_ship_date_end) { this.filterPlannedShipDateEnd = this.commercialScheduleState.planned_ship_date_end; }
      if (this.commercialScheduleState.production_completion_date) { this.filterProductionCompletionDate = this.commercialScheduleState.production_completion_date; }
      if (this.commercialScheduleState.production_completion_date_end) { this.filterProductionCompletionDateEnd = this.commercialScheduleState.production_completion_date_end; }
      if (this.commercialScheduleState.record_type) { this.filterRecordType = this.commercialScheduleState.record_type; }
      if (this.commercialScheduleState.selectedTab) { this.tabChange(this.commercialScheduleState.selectedTab); }
      if (this.commercialScheduleState.isShowStages !== null) { this.isShowStages = this.commercialScheduleState.isShowStages; }
      if (this.commercialScheduleState.isGlassRelated !== null) { this.isGlassRelated = this.commercialScheduleState.isGlassRelated; }
    }
    this.roles = this.user.roles.map((x) => x.id);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.windowWidth = window.innerWidth;
    this.getLocations();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    tableWrapper.addEventListener('scroll', this.checkScroll);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    tableWrapper.removeEventListener('scroll', this.checkScroll);
  },
  methods: {
    async init() {
      this.getJobs();
      this.getGlassPos();
      this.getNoteStatuses();
      await this.$store.dispatch('getHolidays');
    },

    storeState(property, value) {
      const state = this.commercialScheduleState;
      state[property] = value;
      this.$store.commit('storeCommercialScheduleState', state);
    },

    async get() {
      this.loading = true;
      this.items = [];
      this.totalItems = 0;
      const submitModel = {
        filters: {
          status_id: this.status,
          inventory_class_id: this.inventoryClassIdComm,
          stage: this.filterStage,
          job_id: this.filterJob,
          date: this.filterDate,
          po_number: this.filterPo,
          glass_required_by: this.filterGlassReqBy,
          start_date: this.filterPlannedShipDate,
          end_date: this.filterPlannedShipDateEnd,
          start_date_production_completion: this.filterProductionCompletionDate,
          end_date_production_completion: this.filterProductionCompletionDateEnd,
          // location_id: this.filterLocationId,
          record_type: this.filterRecordType,
          job_sub_class_id: this.filterJobSubClass,
          is_glass_related: this.isGlassRelated === true ? 1 : 0,
        },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.commercialSchedule.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loading = false;
      this.init();
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.allItems = [];
        this.totalItems = 0;
        return;
      }
      this.selectedItems = [];
      this.allItems = res.data;
      this.items = res.data.slice(0, 100);
      this.totalItems = res.total;
    },

    async getJobs() {
      this.loadingJobs = true;
      const submitModel = {
        filters: { inventory_class_id: this.inventoryClassIdComm, is_manual: 0 },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        this.loadingJobs = false;
        return;
      }
      this.jobs = res;
      this.loadingJobs = false;
    },

    async getGlassPos() {
      this.loadingPo = true;
      const res = await this.$api.glass.get(`po-numbers/${this.inventoryClassIdComm}/${null}`);
      if (!res) {
        this.poNumbers = [];
        this.loadingPo = false;
        return;
      }
      this.poNumbers.push('N/A');
      this.poNumbers.push(...res);
      this.loadingPo = false;
    },

    async getLocations() {
      this.locations = await this.$api.location.getList();
    },

    async getNoteStatuses() {
      this.noteStatuses = await this.$api.commercialScheduleNoteStatus.get();
    },

    async getWindowAccuracy() {
      const submitModel = {
        // location_id: this.filterLocationId,
        job_sub_class_id: this.filterJobSubClass,
      };
      this.windowAccuracy = await this.$api.commercialSchedule.store(submitModel, 'window-accuracy');
    },

    openCommercialScheduleFinishedGoodForm(item, statusId, stageName, stageId) {
      if (!this.roles.includes(this.userRoleIdAdmin) && !this.roles.includes(this.userRoleIdCommercialScheduleAdmin) && !this.roles.includes(this.userRoleIdAssociate) && !this.roles.includes(this.userRoleIdCommercialScheduleSupervisor)) return;
      this.$refs.commercialScheduleFinishedGoodForm.open(item, statusId, stageName, stageId);
    },

    triggerStageChange(item, status) {
      if (!this.roles.includes(this.userRoleIdAdmin) && !this.roles.includes(this.userRoleIdCommercialScheduleAdmin) && !this.roles.includes(this.userRoleIdAssociate) && !this.roles.includes(this.userRoleIdCommercialScheduleSupervisor)) return;

      if (status === this.materialAvailableId) {
        if (item.is_material_available) {
          this.cancelStage(item.id, this.materialAvailableId);
        } else {
          this.finishStage(item.id, this.materialAvailableId);
        }
      } else if (status === this.cuttingBeforePaintId) {
        if (item.is_cutting_before_paint) {
          this.cancelStage(item.id, this.cuttingBeforePaintId);
        } else {
          this.finishStage(item.id, this.cuttingBeforePaintId);
        }
      } else if (status === this.fabricationId) {
        if (item.is_fabrication) {
          this.cancelStage(item.id, this.fabricationId);
        } else {
          this.finishStage(item.id, this.fabricationId);
        }
      } else if (status === this.assumblyBeforePaintId) {
        if (item.is_assembly_before_paint) {
          this.cancelStage(item.id, this.assumblyBeforePaintId);
        } else {
          this.finishStage(item.id, this.assumblyBeforePaintId);
        }
      } else if (status === this.weldingId) {
        if (item.is_welding) {
          this.cancelStage(item.id, this.weldingId);
        } else {
          this.finishStage(item.id, this.weldingId);
        }
      } else if (status === this.shippingForPaintId) {
        if (item.is_shipping_for_paint) {
          this.cancelStage(item.id, this.shippingForPaintId);
        } else {
          this.finishStage(item.id, this.shippingForPaintId);
        }
      } else if (status === this.hardwareId) {
        if (item.is_hardware) {
          this.cancelStage(item.id, this.hardwareId);
        } else {
          this.finishStage(item.id, this.hardwareId);
        }
      } else if (status === this.cutId) {
        if (item.is_cut) {
          this.finishStage(item.id, this.cutId);
        } else {
          this.finishStage(item.id, this.cutId);
        }
      } else if (status === this.bracketsId) {
        if (item.is_brackets) {
          this.cancelStage(item.id, this.bracketsId);
        } else {
          this.finishStage(item.id, this.bracketsId);
        }
      } else if (status === this.assembledId) {
        if (item.is_assembled) {
          this.cancelStage(item.id, this.assembledId);
        } else {
          this.finishStage(item.id, this.assembledId);
        }
      }
    },

    async finishStage(itemId, status) {
      let title = '';
      let refreshPage = false;
      switch (status) {
        case this.materialAvailableId:
          refreshPage = true;
          title = 'Are you sure that you want to FINISH MATERIAL AVAILABLE?';
          break;
        case this.cuttingBeforePaintId:
          title = 'Are you sure that you want to FINISH CUTTING?';
          break;
        case this.fabricationId:
          title = 'Are you sure that you want to FINISH FABRICATION?';
          break;
        case this.assemblyBeforePaintId:
          title = 'Are you sure that you want to FINISH ASSEMBLY BEFORE PAINT?';
          break;
        case this.weldingId:
          title = 'Are you sure that you want to FINISH WELDING?';
          break;
        case this.shippingForPaintId:
          title = 'Are you sure that you want to FINISH SHIPPING FOR PAINT?';
          break;
        case this.hardwareId:
          title = 'Are you sure that you want to FINISH HARDWARE?';
          break;
        case this.cutId:
          title = 'Are you sure that you want to FINISH CUTTING?';
          break;
        case this.bracketsId:
          title = 'Are you sure that you want to FINISH BRACKETS?';
          break;
        case this.assembledId:
          title = 'Are you sure that you want to FINISH ASSEMBLING?';
          break;
        default:
          break;
      }
      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return;
      const submitModel = {
        id: itemId,
        status,
      };
      const res = await this.$api.commercialSchedule.store(submitModel, 'stage');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.toggleStageUpdate(itemId, status);
      if (refreshPage) {
        this.get();
      }
    },

    async cancelStage(itemId, status) {
      let title = '';
      let refreshPage = false;
      switch (status) {
        case this.materialAvailableId:
          refreshPage = true;
          title = 'Are you sure that you want to CANCEL MATERIAL AVAILABLE?';
          break;
        case this.cuttingBeforePaintId:
          title = 'Are you sure that you want to CANCEL CUTTING?';
          break;
        case this.fabricationId:
          title = 'Are you sure that you want to CANCEL FABRICATION?';
          break;
        case this.assemblyBeforePaintId:
          title = 'Are you sure that you want to CANCEL ASSEMBLY BEFORE PAINT?';
          break;
        case this.weldingId:
          title = 'Are you sure that you want to CANCEL WELDING?';
          break;
        case this.shippingForPaintId:
          title = 'Are you sure that you want to CANCEL SHIPPING FOR PAINT?';
          break;
        case this.hardwareId:
          title = 'Are you sure that you want to CANCEL HARDWARE?';
          break;
        case this.cutId:
          title = 'Are you sure that you want to CANCEL CUTTING?';
          break;
        case this.bracketsId:
          title = 'Are you sure that you want to CANCEL BRACKETS?';
          break;
        case this.assembledId:
          title = 'Are you sure that you want to CANCEL ASSEMBLING?';
          break;
        default:
          break;
      }
      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return;
      const submitModel = {
        id: itemId,
        status,
      };
      const res = await this.$api.commercialSchedule.store(submitModel, 'cancel-stage');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.toggleStageUpdate(itemId, status);
      if (refreshPage) {
        this.get();
      }
    },

    async toggleStageUpdate(itemId, status) {
      const index = this.items.findIndex((x) => x.id === itemId);
      if (index === -1) return;
      switch (status) {
        case this.materialAvailableId:
          this.items[index].is_material_available = !this.items[index].is_material_available;
          break;
        case this.cuttingBeforePaintId:
          this.items[index].is_cutting_before_paint = !this.items[index].is_cutting_before_paint;
          break;
        case this.fabricationId:
          this.items[index].is_fabrication = !this.items[index].is_fabrication;
          break;
        case this.assemblyBeforePaintId:
          this.items[index].is_assembly_before_paint = !this.items[index].is_assembly_before_paint;
          break;
        case this.weldingId:
          this.items[index].is_welding = !this.items[index].is_welding;
          break;
        case this.shippingForPaintId:
          this.items[index].is_shipping_for_paint = !this.items[index].is_shipping_for_paint;
          break;
        case this.hardwareId:
          this.items[index].is_hardware = !this.items[index].is_hardware;
          break;
        case this.cutId:
          this.items[index].is_cutting = !this.items[index].is_cutting;
          break;
        case this.bracketsId:
          this.items[index].is_brackets = !this.items[index].is_brackets;
          break;
        case this.assembledId:
          this.items[index].is_assembled = !this.items[index].is_assembled;
          break;
        // case this.ppStartedId:
        //   this.items[index].is_pp_started = !this.items[index].is_pp_started;
        //   break;
        // case this.ppFinishedId:
        //   this.items[index].is_pp_finished = !this.items[index].is_pp_finished;
        //   break;
        default:
          break;
      }
      this.$set(this.items, index, this.items[index]);
    },

    async toggle(id, statusId, isArchive = false) {
      let title = '';
      if (isArchive) {
        title = 'ARCHIVE';
      } else if (statusId === this.statusIdInProgress) {
        title = 'COMPLETE';
      } else {
        title = 'RESTORE';
      }
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${title} this record?`,
      });
      if (!confirm) return;
      const res = await this.$api.commercialSchedule.get(`toggle/${id}/${statusId}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.commercialForm.open();
    },

    // openManual() {
    //   this.$refs.manualForm.open();
    // },

    openEdit(item) {
      this.$refs.commercialForm.open(item.id);
    },

    openNotes(id) {
      this.$refs.commercialScheduleNoteForm.open(id);
    },

    // openHistory(id) {
    //   this.$refs.commercialScheduleHistoryForm.open(id);
    // },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.commercialSchedule.delete(id);
      this.$bus.$emit('loading');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
      this.windowWidth = window.innerWidth;
    },

    getScheduleDateLimitDate(limitDate, items = [this.selectedItem]) {
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const isDateUnrestricted = itemsToCheck.length > 0 && itemsToCheck.every((item) => item
        && parseInt(item.sp_note_status_id, 10) === this.noteStatusIdOk
        && parseInt(item.su_note_status_id, 10) === this.noteStatusIdOk);
      return isDateUnrestricted ? null : limitDate;
    },

    getProductionCompletionDateForGlassRequiredByDate(item, glassRequiredByDate) {
      if (!item) return glassRequiredByDate;
      return this.shouldMoveProductionCompletionDateForGlassRequiredBy(glassRequiredByDate, item.production_completion_date)
        ? glassRequiredByDate
        : item.production_completion_date;
    },

    getProductionCompletionDateForPlannedShipDate(item, plannedShipDate) {
      if (!item) return plannedShipDate;
      return this.shouldMoveProductionCompletionDateForPlannedShipDate(item.production_completion_date, plannedShipDate)
        ? plannedShipDate
        : item.production_completion_date;
    },

    getGlassRequiredByDateForProductionCompletionDate(item, productionCompletionDate) {
      if (!item) return productionCompletionDate;
      return this.shouldMoveGlassRequiredByDateForProductionCompletionDate(item.glass_required_by, productionCompletionDate)
        ? productionCompletionDate
        : item.glass_required_by;
    },

    getGlassRequiredByDateForPlannedShipDate(item, plannedShipDate) {
      const productionCompletionDate = this.getProductionCompletionDateForPlannedShipDate(item, plannedShipDate);
      return this.getGlassRequiredByDateForProductionCompletionDate(item, productionCompletionDate);
    },

    getChangedGlassRequiredByDateForProductionCompletionDate(item, productionCompletionDate) {
      if (!item) return productionCompletionDate;
      return this.shouldMoveGlassRequiredByDateForProductionCompletionDate(item.glass_required_by, productionCompletionDate)
        ? productionCompletionDate
        : null;
    },

    getChangedGlassRequiredByDateForPlannedShipDate(item, plannedShipDate) {
      const productionCompletionDate = this.getProductionCompletionDateForPlannedShipDate(item, plannedShipDate);
      return this.getChangedGlassRequiredByDateForProductionCompletionDate(item, productionCompletionDate);
    },

    getUniqueDates(dates) {
      return [...new Set(dates.filter((date) => !!date))];
    },

    shouldMoveProductionCompletionDateForGlassRequiredBy(glassRequiredByDate, productionCompletionDate) {
      return !productionCompletionDate || glassRequiredByDate > productionCompletionDate;
    },

    shouldMoveGlassRequiredByDateForProductionCompletionDate(glassRequiredByDate, productionCompletionDate) {
      return !glassRequiredByDate || glassRequiredByDate > productionCompletionDate;
    },

    shouldMoveProductionCompletionDateForPlannedShipDate(productionCompletionDate, plannedShipDate) {
      if (!productionCompletionDate) return true;
      return plannedShipDate < productionCompletionDate;
    },

    shouldMovePlannedShipDateForProductionCompletionDate(plannedShipDate, productionCompletionDate) {
      if (!plannedShipDate) return true;
      return plannedShipDate < productionCompletionDate;
    },

    getSealedUnitOverbookingPoNumber(items = [this.selectedItem]) {
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const itemWithSuPoNumber = itemsToCheck.find((item) => item
        && parseInt(item.status_id, 10) !== this.statusIdCompleted
        && item.su_po_number);
      return itemWithSuPoNumber ? itemWithSuPoNumber.su_po_number : null;
    },

    resetSealedUnitOverbookedValidation() {
      this.isSealedUnitOverbooked = false;
      this.isCheckingSealedUnitCount = false;
      this.isSealedUnitCountChecked = false;
      this.sealedUnitOverbookedDate = null;
    },

    async validateSealedUnitCountForDate(date, items = [this.selectedItem], options = {}) {
      const { silent = false } = options;
      if (!silent) this.resetSealedUnitOverbookedValidation();
      if (!date || !this.businessRulesGetBoolean('Sealed Unit Overbooking Check')) return true;

      const sealedUnitOverbookingPoNumber = this.getSealedUnitOverbookingPoNumber(items);

      if (!silent) {
        this.isCheckingSealedUnitCount = true;
        this.isSealedUnitCountChecked = false;
        this.sealedUnitOverbookedDate = date;
      }

      try {
        const overbookingCheck = await this.$api.glass.store({
          glass_required_by: date,
          po_number: sealedUnitOverbookingPoNumber || null,
        }, 'sealed-unit-overbooking-check');

        if (!silent && this.sealedUnitOverbookedDate !== date) return true;

        if (!overbookingCheck || overbookingCheck.status === 'error') {
          this.$bus.$emit('showError', overbookingCheck && overbookingCheck.message ? overbookingCheck.message : 'Unable to check sealed unit count. Please try again.');
          return false;
        }

        this.maximumSealedUnitsAllowedPerDay = overbookingCheck.maximum_sealed_units_allowed_per_day || this.maximumSealedUnitsAllowedPerDay;
        if (silent && overbookingCheck.is_overbooked) {
          this.sealedUnitOverbookedDate = date;
          this.isSealedUnitOverbooked = true;
          this.isSealedUnitCountChecked = true;
        }
        if (silent) return !overbookingCheck.is_overbooked;

        this.isSealedUnitOverbooked = overbookingCheck.is_overbooked;
        this.isSealedUnitCountChecked = true;
        return !this.isSealedUnitOverbooked;
      } finally {
        if (!silent && this.sealedUnitOverbookedDate === date) {
          this.isCheckingSealedUnitCount = false;
        }
      }
    },

    async validateSealedUnitCountsForMultipleDates(dates, items = [this.selectedItem], options = {}) {
      const uniqueDates = this.getUniqueDates(dates);
      const itemsToCheck = Array.isArray(items) ? items : [items];
      if (!uniqueDates.length) {
        if (!options.silent) this.resetSealedUnitOverbookedValidation();
        return true;
      }

      for (let i = 0; i < uniqueDates.length; i += 1) {
        const date = uniqueDates[i];
        const itemsForDate = itemsToCheck.filter((item, index) => dates[index] === date);
        // eslint-disable-next-line no-await-in-loop
        const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(date, itemsForDate.length ? itemsForDate : itemsToCheck, options);
        if (!isValidSealedUnitDate) return false;
      }

      return true;
    },

    onGlassRequiredByDateChange(date, items = [this.selectedItem]) {
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const dates = itemsToCheck.map(() => date);
      this.validateSealedUnitCountsForMultipleDates(dates, itemsToCheck);
    },

    onProductionCompletionDateChange(productionCompletionDate, items = [this.selectedItem]) {
      if (!productionCompletionDate) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }

      const itemsToCheck = Array.isArray(items) ? items : [items];
      const dates = itemsToCheck.map((item) => this.getChangedGlassRequiredByDateForProductionCompletionDate(item, productionCompletionDate));
      this.validateSealedUnitCountsForMultipleDates(dates, itemsToCheck);
    },

    onPlannedShipDateChange(plannedShipDate, items = [this.selectedItem]) {
      if (!plannedShipDate) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }

      const itemsToCheck = Array.isArray(items) ? items : [items];
      const dates = itemsToCheck.map((item) => this.getChangedGlassRequiredByDateForPlannedShipDate(item, plannedShipDate));
      this.validateSealedUnitCountsForMultipleDates(dates, itemsToCheck);
    },

    clearAllFilters() {
      this.filterJob = null;
      this.filterPo = null;
      this.filterStage = null;
      this.filterGlassReqBy = null;
      this.filterPlannedShipDate = null;
      this.filterPlannedShipDateEnd = null;
      // this.filterLocationId = null;
      this.filterRecordType = null;
      this.filterProductionCompletionDate = null;
      this.filterProductionCompletionDateEnd = null;
    },

    async runWebhook(documentType) {
      this.$bus.$emit('loading');
      const MODULE_PRODUCTION_SCHEDULE_ID = 20;
      let status = 'Current';
      if (this.status === 2) {
        status = 'Archived';
      }
      const submitModel = {
        status,
        inventory_class_id: this.inventoryClassIdComm,
        module_id: MODULE_PRODUCTION_SCHEDULE_ID,
        // location_id: this.filterLocationId ? this.filterLocationId : 0,
        sub_class: this.filterJobSubClass ? this.filterJobSubClass : 0,
        is_show_stages: this.isShowStages === true ? 'Yes' : 'No',
        is_show_glass_related: this.isGlassRelated === true ? 'Yes' : 'No',
      };
      const res = await this.$api.webhook.store(submitModel, 'run');
      if (!res) return;
      const pdf = await this.$api.report.download(res.id, documentType);
      if (!pdf) {
        this.$bus.$emit('showError', 'Report Failed');
        return;
      }
      const now = FormatHelpers.getFileTimestamp();
      const fileName = `Report_${res.report_title}_${now}`;
      const file = new Blob([pdf], {
        type: documentType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel',
      });
      if (documentType === 'pdf') {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

    openGlassRequiredByDateForm(item) {
      this.resetSealedUnitOverbookedValidation();
      this.selectedItem = item;
      this.minGlassRequiredByDate = this.getMinGlassRequiredByDate(item.glass_required_by);
      this.dialogShipDate = true;
    },

    openGlassRequiredByDateFormMultiple() {
      this.resetSealedUnitOverbookedValidation();
      this.glassRequiredByDateMultiple = null;
      this.dialogGlassRequiredByDateMultiple = true;
    },

    async updateGlassRequiredByDate(id, glassRequiredByDate) {
      const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(glassRequiredByDate, [this.selectedItem], { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const res = await this.$api.commercialSchedule.update({ id, glass_required_by: glassRequiredByDate }, 'glass-required-by-date');
        if (!res) return;

        let productionCompletionDate = this.selectedItem.production_completion_date;
        if (this.shouldMoveProductionCompletionDateForGlassRequiredBy(glassRequiredByDate, productionCompletionDate)) {
          productionCompletionDate = glassRequiredByDate;
          const resProd = await this.$api.commercialSchedule.update(
            { id, production_completion_date: productionCompletionDate, production_completion_time: '07:00' },
            'production-completion-date',
          );
          if (!resProd) return;
        }

        if (
          productionCompletionDate
          && this.shouldMovePlannedShipDateForProductionCompletionDate(this.selectedItem.planned_ship_date, productionCompletionDate)
        ) {
          const resPlanned = await this.$api.commercialSchedule.update(
            { id, planned_ship_date: productionCompletionDate, planned_ship_time: this.selectedItem.planned_ship_time },
            'planned-ship-date',
          );
          if (!resPlanned) return;
        }

        this.$bus.$emit('showSuccess');
        this.dialogShipDate = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updateGlassRequiredByDateMultiple() {
      const glassRequiredByDates = this.selectedItems.map(() => this.glassRequiredByDateMultiple);
      const isValidSealedUnitDate = await this.validateSealedUnitCountsForMultipleDates(glassRequiredByDates, this.selectedItems, { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const items = [];
        this.selectedItems.forEach((x) => {
          items.push(this.$api.commercialSchedule.update({ id: x.id, glass_required_by: this.glassRequiredByDateMultiple }, 'glass-required-by-date'));
        });
        const itemsRes = await Promise.all(items);
        if (itemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const productions = [];
        const plannedShipDateItems = [];
        this.selectedItems.forEach((x) => {
          let productionCompletionDate = x.production_completion_date;
          if (this.shouldMoveProductionCompletionDateForGlassRequiredBy(this.glassRequiredByDateMultiple, productionCompletionDate)) {
            productionCompletionDate = this.glassRequiredByDateMultiple;
            productions.push(
              this.$api.commercialSchedule.update(
                { id: x.id, production_completion_date: productionCompletionDate, production_completion_time: '07:00' },
                'production-completion-date',
              ),
            );
          }

          if (
            productionCompletionDate
            && this.shouldMovePlannedShipDateForProductionCompletionDate(x.planned_ship_date, productionCompletionDate)
          ) {
            plannedShipDateItems.push(
              this.$api.commercialSchedule.update(
                {
                  id: x.id,
                  planned_ship_date: productionCompletionDate,
                  planned_ship_time: x.planned_ship_time,
                },
                'planned-ship-date',
              ),
            );
          }
        });

        const productionsRes = await Promise.all(productions);

        if (productionsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const plannedShipDateItemsRes = await Promise.all(plannedShipDateItems);

        if (plannedShipDateItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        this.$bus.$emit('showSuccess');
        this.dialogGlassRequiredByDateMultiple = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    openPlannedShipDateForm(item) {
      this.resetSealedUnitOverbookedValidation();
      this.selectedItem = item;
      this.dialogPlannedDate = true;
    },

    openPlannedShipDateMultipleForm() {
      this.resetSealedUnitOverbookedValidation();
      this.plannedShipDateMultiple = null;
      this.dialogPlannedShipDateMultiple = true;
    },

    async updatePlannedShipDate(id, plannedShipDate, plannedShipTime) {
      const glassRequiredByDateToValidate = this.getChangedGlassRequiredByDateForPlannedShipDate(this.selectedItem, plannedShipDate);
      if (glassRequiredByDateToValidate) {
        const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(glassRequiredByDateToValidate, [this.selectedItem], { silent: true });
        if (!isValidSealedUnitDate) return;
      }

      this.$bus.$emit('loading');
      try {
        const res = await this.$api.commercialSchedule.update({ id, planned_ship_date: plannedShipDate, planned_ship_time: plannedShipTime }, 'planned-ship-date');
        if (!res) {
          this.$bus.$emit('showError');
          return;
        }

        let productionCompletionDate = this.selectedItem.production_completion_date;
        if (this.shouldMoveProductionCompletionDateForPlannedShipDate(productionCompletionDate, plannedShipDate)) {
          productionCompletionDate = plannedShipDate;
          const resProd = await this.$api.commercialSchedule.update(
            { id, production_completion_date: productionCompletionDate },
            'production-completion-date',
          );

          if (!resProd) {
            this.$bus.$emit('showError');
            return;
          }
        }

        if (this.shouldMoveGlassRequiredByDateForProductionCompletionDate(this.selectedItem.glass_required_by, productionCompletionDate)) {
          const resGlass = await this.$api.commercialSchedule.update(
            { id, glass_required_by: productionCompletionDate },
            'glass-required-by-date',
          );

          if (!resGlass) {
            this.$bus.$emit('showError');
            return;
          }
        }

        this.$bus.$emit('showSuccess');
        this.dialogPlannedDate = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updatePlannedShipDateMultiple() {
      const valid = await this.$refs.formJob.validate();
      if (!valid) return;

      const glassRequiredByDates = this.selectedItems.map((item) => this.getChangedGlassRequiredByDateForPlannedShipDate(item, this.plannedShipDateMultiple));
      const isValidSealedUnitDate = await this.validateSealedUnitCountsForMultipleDates(glassRequiredByDates, this.selectedItems, { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const items = [];
        this.selectedItems.forEach((x) => {
          items.push(this.$api.commercialSchedule.update({ id: x.id, planned_ship_date: this.plannedShipDateMultiple, location_id: this.selectedLocationId }, 'planned-ship-date'));
        });
        const itemsRes = await Promise.all(items);
        if (itemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const productions = [];
        const glassItems = [];
        this.selectedItems.forEach((x) => {
          let productionCompletionDate = x.production_completion_date;
          if (this.shouldMoveProductionCompletionDateForPlannedShipDate(productionCompletionDate, this.plannedShipDateMultiple)) {
            productionCompletionDate = this.plannedShipDateMultiple;
            productions.push(
              this.$api.commercialSchedule.update(
                { id: x.id, production_completion_date: productionCompletionDate },
                'production-completion-date',
              ),
            );
          }

          if (this.shouldMoveGlassRequiredByDateForProductionCompletionDate(x.glass_required_by, productionCompletionDate)) {
            glassItems.push(
              this.$api.commercialSchedule.update(
                { id: x.id, glass_required_by: productionCompletionDate },
                'glass-required-by-date',
              ),
            );
          }
        });

        const productionsRes = await Promise.all(productions);

        if (productionsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const glassItemsRes = await Promise.all(glassItems);

        if (glassItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        this.$bus.$emit('showSuccess');
        this.dialogPlannedShipDateMultiple = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    openProductionCompletionDateForm(item) {
      this.resetSealedUnitOverbookedValidation();
      this.selectedItem = item;
      this.dialogProductionCompletionDate = true;
    },

    openProductionCompletionDateMultipleForm() {
      this.resetSealedUnitOverbookedValidation();
      this.productionCompletionDateMultiple = null;
      this.dialogProductionCompletionDateMultiple = true;
    },

    async updateProductionCompletionDate(id, productionCompletionDate, productionCompletionTime) {
      const glassRequiredByDateToValidate = this.getChangedGlassRequiredByDateForProductionCompletionDate(this.selectedItem, productionCompletionDate);
      if (glassRequiredByDateToValidate) {
        const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(glassRequiredByDateToValidate, [this.selectedItem], { silent: true });
        if (!isValidSealedUnitDate) return;
      }

      this.$bus.$emit('loading');
      try {
        const res = await this.$api.commercialSchedule.update({ id, production_completion_date: productionCompletionDate, production_completion_time: productionCompletionTime }, 'production-completion-date');
        if (!res) return;

        if (this.shouldMoveGlassRequiredByDateForProductionCompletionDate(this.selectedItem.glass_required_by, productionCompletionDate)) {
          const resGlass = await this.$api.commercialSchedule.update(
            { id, glass_required_by: productionCompletionDate },
            'glass-required-by-date',
          );
          if (!resGlass) return;
        }

        if (this.shouldMovePlannedShipDateForProductionCompletionDate(this.selectedItem.planned_ship_date, productionCompletionDate)) {
          const resPlanned = await this.$api.commercialSchedule.update(
            { id, planned_ship_date: productionCompletionDate, planned_ship_time: this.selectedItem.planned_ship_time },
            'planned-ship-date',
          );
          if (!resPlanned) return;
        }

        this.$bus.$emit('showSuccess');
        this.dialogProductionCompletionDate = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updateProductionCompletionDateMultiple() {
      const glassRequiredByDates = this.selectedItems.map((item) => this.getChangedGlassRequiredByDateForProductionCompletionDate(item, this.productionCompletionDateMultiple));
      const isValidSealedUnitDate = await this.validateSealedUnitCountsForMultipleDates(glassRequiredByDates, this.selectedItems, { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const items = [];
        this.selectedItems.forEach((x) => {
          items.push(this.$api.commercialSchedule.update({ id: x.id, production_completion_date: this.productionCompletionDateMultiple }, 'production-completion-date'));
        });
        const itemsRes = await Promise.all(items);
        if (itemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const glassItems = [];
        const plannedShipDateItems = [];
        this.selectedItems.forEach((x) => {
          if (this.shouldMoveGlassRequiredByDateForProductionCompletionDate(x.glass_required_by, this.productionCompletionDateMultiple)) {
            glassItems.push(
              this.$api.commercialSchedule.update(
                { id: x.id, glass_required_by: this.productionCompletionDateMultiple },
                'glass-required-by-date',
              ),
            );
          }

          if (this.shouldMovePlannedShipDateForProductionCompletionDate(x.planned_ship_date, this.productionCompletionDateMultiple)) {
            plannedShipDateItems.push(
              this.$api.commercialSchedule.update(
                {
                  id: x.id,
                  planned_ship_date: this.productionCompletionDateMultiple,
                  planned_ship_time: x.planned_ship_time,
                },
                'planned-ship-date',
              ),
            );
          }
        });

        const glassItemsRes = await Promise.all(glassItems);

        if (glassItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const plannedShipDateItemsRes = await Promise.all(plannedShipDateItems);

        if (plannedShipDateItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        this.$bus.$emit('showSuccess');
        this.dialogProductionCompletionDateMultiple = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updateProductionBacklog() {
      if (!this.selectedProdBacklogItem) return;
      this.selectedProdBacklogItem.production_backlog = this.selectedProdBacklogItem.production_backlog || this.selectedProdBacklogItem.production_backlog === 0 ? this.selectedProdBacklogItem.production_backlog : null;
      const res = await this.$api.commercialSchedule.update({ id: this.selectedProdBacklogItem.id, production_backlog: this.selectedProdBacklogItem.production_backlog }, 'production-backlog');
      if (!res) return;
      this.get();
      this.dialogProdBacklogSchedule = false;
    },

    async updateShipBacklog() {
      if (!this.selectedShipBacklogItem) return;
      this.selectedShipBacklogItem.shipping_backlog = this.selectedShipBacklogItem.shipping_backlog || this.selectedShipBacklogItem.shipping_backlog === 0 ? this.selectedShipBacklogItem.shipping_backlog : null;
      const res = await this.$api.commercialSchedule.update({ id: this.selectedShipBacklogItem.id, shipping_backlog: this.selectedShipBacklogItem.shipping_backlog }, 'shipping-backlog');
      if (!res) return;
      this.get();
      this.dialogShipBacklogSchedule = false;
    },

    async updateSPGlassNote() {
      if (!this.selectedItem) return;
      if (this.selectedItem.sp_note_status_id !== this.noteStatusIdShort) {
        this.selectedItem.sp_note = null;
      }
      const res = await this.$api.commercialSchedule.update({ id: this.selectedItem.id, sp_note_status_id: this.selectedItem.sp_note_status_id, sp_note: this.selectedItem.sp_note }, 'sp-glass-note');
      if (!res) return;
      const index = this.items.findIndex((x) => x.id === this.selectedItem.id);
      if (index === -1) return;
      this.items[index].sp_note = this.selectedItem.sp_note;
      this.items[index].sp_note_status_id = this.selectedItem.sp_note_status_id;
      const spNote = this.noteStatuses.find((x) => x.id === this.selectedItem.sp_note_status_id);
      this.items[index].sp_note_status = spNote;
      this.$set(this.items, index, this.items[index]);
      this.dialogSPGlassNote = false;
    },

    async updateSUGlassNote() {
      if (!this.selectedItem) return;
      if (this.selectedItem.su_note_status_id !== this.noteStatusIdShort) {
        this.selectedItem.su_note = null;
      }
      const res = await this.$api.commercialSchedule.update({ id: this.selectedItem.id, su_note_status_id: this.selectedItem.su_note_status_id, su_note: this.selectedItem.su_note }, 'su-glass-note');
      if (!res) return;
      const index = this.items.findIndex((x) => x.id === this.selectedItem.id);
      if (index === -1) return;
      this.items[index].su_note = this.selectedItem.su_note;
      this.items[index].su_note_status_id = this.selectedItem.su_note_status_id;
      const suNote = this.noteStatuses.find((x) => x.id === this.selectedItem.su_note_status_id);
      this.items[index].su_note_status = suNote;
      this.$set(this.items, index, this.items[index]);
      this.dialogSUGlassNote = false;
    },

    // openTruckForm(item) {
    //   this.$refs.approveForm.openProductionSchedule(item);
    // },

    async archiveAll() {
      const confirm = await this.$refs.confirmForm.open({
        // eslint-disable-next-line eqeqeq
        title: `Are you sure that you want to ${this.status == 1 ? 'ARCHIVE' : 'RESTORE'} all selected records?`,
      });
      if (!confirm) return;
      const requests = [];
      this.selectedItems.forEach((x) => {
        requests.push(this.$api.commercialSchedule.get(`toggle/${x.id}/${x.status_id}`));
      });

      const res = await Promise.all(requests);
      if (res.includes(false)) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    tabChange(item) {
      if (this.selectedTab === item) {
        this.selectedTab = null;
        this.filterJobSubClass = null;
        this.get();
        this.getWindowAccuracy();
        this.storeState('selectedTab', null);
        return;
      }
      this.selectedTab = item;
      this.filterJobSubClass = item.sub_class_id;
      this.storeState('selectedTab', item);
      this.get();
      this.getWindowAccuracy();
    },

    openMenuProdBacklog(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedProdBacklogItem = this.items[index];
      this.dialogProdBacklogSchedule = true;
    },

    openMenuSPGlassNote(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedItem = this.items[index];
      this.dialogSPGlassNote = true;
    },
    openMenuSUGlassNote(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedItem = this.items[index];
      this.dialogSUGlassNote = true;
    },

    openMenuShipBacklog(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedShipBacklogItem = this.items[index];
      this.dialogShipBacklogSchedule = true;
    },

    // redirectTrucks(jobId) {
    //   this.$router.push({ name: 'TruckScheduleRequestView', params: { jobIdProp: jobId } });
    // },

    openFinishedGoods() {
      this.$refs.commercialScheduleFinishedGoodGroupedForm.open();
    },

    async sendEmailPdf() {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to send an email containing the latest Production Schedule reports?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.productionSchedule.get('send-email-pdf');
      this.$bus.$emit('loading');
      if (res) {
        this.$bus.$emit('showSuccess');
      } else {
        this.$bus.$emit('showError');
      }
    },

    openWindowBreakdown(item, typeId) {
      const data = {
        work_order: item.wo_number,
        project_name: item.project,
        reference: item.project_floor,
      };
      this.$refs.windowBreakdownItemsForm.open(data, typeId);
    },

    checkScroll(event) {
      const bottomOfTable = (event.target.scrollHeight < event.target.scrollTop + event.target.clientHeight + 5 && event.target.scrollHeight > event.target.scrollTop + event.target.clientHeight - 5) || event.target.scrollHeight === event.target.scrollTop + event.target.clientHeight;
      if (bottomOfTable) {
        this.items = this.allItems.slice(0, this.items.length + 100);
      }
    },

    openReturnedWindows() {
      this.$refs.billOfLadingReturnedWindowsForm.open();
    },

    isJobFinished(item) {
      if (item.is_shipping === 1) {
        return true;
      }
      return false;
    },

    isJobShipped(item) {
      if (item.is_received === 1) {
        return true;
      }
      return false;
    },

    formatLocation(location) {
      const [num, word] = location.trim().split(' ');
      return `${num} ${word.slice(0, 2)}`;
    },

    delay(item) {
      this.$refs.commercialScheduleDelayReasonForm.open(item);
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
      this.storeState('pagination', newOptions);
    },

    getMinDate(multiple = false) {
      // eslint-disable-next-line eqeqeq
      if (this.status != this.statusIdOnHand) return this.today;

      let item = null;

      if (multiple) {
        if (!this.selectedItems || this.selectedItems.length !== 1) return this.dayAfterSix;
        // eslint-disable-next-line prefer-destructuring
        item = this.selectedItems[0];
      } else {
        if (!this.selectedItem) return this.dayAfterSix;
        item = this.selectedItem;
      }

      if (!item.job) return this.dayAfterSix;
      const subclassIdCornerPost = 2;
      if (item.job.sub_class_id === subclassIdCornerPost || item.job.reference.includes('BS')) {
        return this.today;
      }
      return this.dayAfterSix;
    },

    getMinGlassRequiredByDate() {
      return addBusinessDays(this.today, 4, this.holidaysDateToNameMap);
    },

    getMinDateProd() {
      return addBusinessDays(this.today, 4, this.holidaysDateToNameMap);
    },

    getMinShipDate() {
      return addBusinessDays(this.today, 4, this.holidaysDateToNameMap);
    },

    isCommDoors(item) {
      if (item.sub_class_id) {
        return Number(item.sub_class_id) === this.subClassIdCommDoors;
      }

      if (item.job && item.job.sub_class_id) {
        return Number(item.job.sub_class_id) === this.subClassIdCommDoors;
      }

      return false;
    },

    isCommWindows(item) {
      if (item.sub_class_id) {
        return Number(item.sub_class_id) === this.subClassIdCommWindows;
      }

      if (item.job && item.job.sub_class_id) {
        return Number(item.job.sub_class_id) === this.subClassIdCommWindows;
      }

      return false;
    },

    isCuttingBeforePaintComplete(item) {
      if (this.isCommDoors(item)) {
        return item.is_shipping_for_paint == 1;
      }

      if (this.isCommWindows(item)) {
        return item.is_prod_backlog == 1;
      }

      return false;
    },
  },
};
</script>

<style scoped>

.business-date-picker-dialog-title {
  background-color: #323232;
  color: #FFFFFF;
}

.business-date-picker-dialog-action-divider {
  width: calc(100% - 48px);
  margin: 0 auto;
  border-top: 1px solid #E0E0E0;
}

#cellOverflow {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  min-width: 120px  !important;
  border-left: 1px solid #E0E0E0;
  background-color: #FAFAFA;

}

#cellOverflow.theme--dark {
  background-color: #323232;
}

span
{
  font-size: 12px !important;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: #323232;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th > span {
  color: #FFFFFF;
}

::v-deep .theme--light.v-divider {
    border-color: rgba(0,0,0,0.4) !important;
    border: 1px solid rgba(0,0,0,0.4) !important;
}

:v-deep .v-btn__content
{
  color: white !important;
}

.box
{
  border-radius: 4px;
   width: 25px;
    height: 25px;
}

.empty-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFFFFF;
}

.red-box
{
  border: 1.5px solid #F44336;
  background-color: #F44336;
}

.yellow-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFD84D;
}

.green-box
{
  border: 1.5px solid #4CAF50;
  background-color: #4CAF50;
}

.options-item-div
{
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
